import axiosIns from '@/api/axios'
import axiosInsAcademy from '@/api/axios-ugems-academy'

export const GET_LSP = (params) => {
    return axiosInsAcademy.get('/lsps', { params })
}

export const GET_LSP_BY_ID = (id) => {
  return axiosInsAcademy.get(`/lsps/${id}`)
}

export const CREATE_LSP = (data) => {
    return axiosInsAcademy.post('/lsps', data)
}

export const UPDATE_LSP = (id, data) => {
    return axiosInsAcademy.put(`/lsps/${id}`, data)
}

export const DELETE_LSP = (id) => {
    return axiosInsAcademy.delete(`/lsps/${id}`)
}